import { useState } from "react"
import PracticeUserList from "./practicesAssociationTabs/practiceUserList"
import FaxNumberAssignment from "./practicesAssociationTabs/faxNumberAssignment"
const PracticesAssociation = ({ authUser }) => {
  const [tab, setTab] = useState("faxnumber")

  const getAdminProps = () => {
    if (tab === "admin") {
      return {
        api: {
          getUser:
            "/admin/all/ssoCustomers?role=ADMIN&includeAssignedPractices=true",
          fetchOptions: "/practice/fetchFaxNumberAssignedPractices",
          assign: "/practice/adminPracticeAssociation",
        },
      }
    } else if (tab === "user") {
      return {
        api: {
          getUser:
            "/admin/all/ssoCustomers?role=USER&includeAssignedPractices=true",
          fetchOptions: "/practice/fetchFaxNumberAssignedPractices",
          assign: "/practice/associate-user-practices",
        },
      }
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <div style={{ width: "100%", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            marginTop: "20px",
            marginLeft: "20px",
          }}
        >
          <label className="radio-option-label">
            <input
              type="radio"
              value="faxnumber"
              checked={tab === "faxnumber"}
              onChange={() => setTab("faxnumber")}
            />
            FaxNumber
          </label>
          <label className="radio-option-label">
            <input
              type="radio"
              value="admin"
              checked={tab === "admin"}
              onChange={() => setTab("admin")}
            />
            Admin
          </label>
          <label className="radio-option-label">
            <input
              type="radio"
              value="user"
              checked={tab === "user"}
              onChange={() => setTab("user")}
            />
            User
          </label>
        </div>

        {/* Content */}
        {tab && tab !== "faxnumber" && (
              <PracticeUserList
                key={tab} // This will remount the Admin component on tab change
                tab={tab}
                {...getAdminProps()}
              />
            )}

            {tab === "faxnumber" && <FaxNumberAssignment authUser={authUser} />}
        </div>
    </div>
  )
}

export default PracticesAssociation
